{
  "tools_blocked_hint": "No access for the owner. The tool is not offered at run time.",
  "title": "Agents",
  "list_title": "Agents",
  "no_agents": "No agents yet",
  "select_or_new": "Select an agent on the right or create a new one.",
  "type": {
    "master": "Master",
    "project": "Project",
    "specialist": "Specialist"
  },
  "fields": {
    "type": "Type",
    "model": "Model",
    "temperature": "Temperature",
    "max_tokens": "Max tokens",
    "max_tokens_thinking_warning": "⚠ With Thinking enabled, max_tokens < 8000 can trigger \"max_tokens reached\" aborts. Recommended: ≥ 16384.",
    "description": "Description",
    "tools": "Tools",
    "tools_count": "Tools ({{selected}}/{{total}})",
    "mcp_servers": "MCP servers",
    "mcp_count": "MCP servers ({{selected}}/{{total}})",
    "system_prompt": "System prompt",
    "model_not_in_config": "{{model}} (not in LLM config)",
    "fallback_models": "Fallback models",
    "fallback_hint": "On quota/overload/auth errors of the primary model these are tried in order. Use ↑ to reorder.",
    "domain": "Domain",
    "domain_placeholder": "e.g. Database, Security, Infrastructure",
    "thinking_budget": "Extended Thinking budget: {{tokens}} tokens",
    "thinking_hint": "Only relevant for Anthropic Extended-Thinking models. 0 = off.",
    "require_tool_confirm": "Confirm tools before execution",
    "require_tool_confirm_hint": "When active: a banner appears in chat before each tool call with Allow/Deny. Auto-deny after 5 minutes.",
    "max_iterations": "Max iterations: {{count}}",
    "max_iterations_hint": "Maximum tool loops per run (default: 16, maximum: 250).",
    "handoff_timeout": "Specialist timeout (seconds)",
    "handoff_timeout_hint": "Maximum runtime of a delegated task (30–3600 seconds)."
  },
  "info": {
    "title": "Info",
    "id": "ID",
    "owner": "Owner",
    "created_by": "Created by",
    "created_at": "Created at",
    "workspace": "Workspace",
    "project": "Project ID"
  },
  "unsaved_hint": "You have unsaved changes.",
  "tabs": {
    "overview": "Overview",
    "model": "Model",
    "tools": "Tools & MCP",
    "mail": "Mailbox",
    "skills": "Skills",
    "soul": "Soul",
    "advanced": "Advanced"
  },
  "mail": {
    "intro": "Dedicated mailbox for this buddy. All empty = the global mail settings (System → Settings → Mail) are used. Filled = this buddy sends/reads via its own account.",
    "smtp_title": "SMTP (sending)",
    "imap_title": "IMAP (receiving)",
    "host": "Host",
    "port": "Port",
    "user": "User",
    "password": "Password",
    "from": "Sender (From)",
    "starttls": "STARTTLS",
    "tls_hint": "Port 465 uses implicit SSL automatically. STARTTLS applies to 587.",
    "password_placeholder": "Enter password",
    "password_keep": "•••••••• (set — leave empty to keep)",
    "imap_host_ph": "empty = same as SMTP host",
    "imap_login_ph": "empty = same as SMTP login",
    "global_suffix": " (global)"
  },
  "soul": {
    "description": "Identity, behavior and background of the agent as Markdown files.",
    "replaces_prompt_hint": "As soon as one field is filled, the soul replaces the system prompt completely.",
    "prompt_inactive": "Soul active — this system prompt is not used. The agent uses the soul files (tab “Soul”). Clear all fields there to use this prompt again.",
    "load_template": "Load template",
    "save_component": "Save",
    "saved": "Saved",
    "loading": "Loading soul...",
    "empty_hint": "Leave empty = inactive",
    "identity": "Identity",
    "identity_hint": "Who am I? Name, character, vibe.",
    "behavior": "Behavior",
    "behavior_hint": "How do I work? Principles, boundaries.",
    "background": "Background",
    "background_hint": "Optional: context, domain knowledge."
  },
  "tool_categories": {
    "all": "All ({{count}})",
    "files": "Files",
    "shell": "Shell",
    "memory": "Memory",
    "web": "Web",
    "tasks": "Tasks",
    "mail": "Mail",
    "discord": "Discord",
    "agents": "Agents",
    "other": "Other",
    "plugin": "Plugin: {{name}}"
  },
  "errors": {
    "save_failed": "Save failed",
    "delete_confirm": "Really delete agent \"{{name}}\"? Includes memory + workspace.",
    "no_servers_yet": "No MCP servers configured yet — see MCP tab."
  },
  "new_dialog": {
    "title": "Create new agent",
    "type_label": "Type",
    "model_label": "Model",
    "no_model": "(no model)",
    "name_label": "Name",
    "name_placeholder": "e.g. Research-Bot",
    "defaults_hint": "Default tools for {{type}}: {{count}}",
    "template_label": "Template (optional)",
    "template_none": "— No template —",
    "template_hint": "Template applied: {{count}} tools, system prompt included"
  },
  "compaction": {
    "section_title": "Compaction",
    "section_hint": "When and how the conversation gets summarized",
    "model": "Compact model",
    "model_main": "Same as main model ({{model}})",
    "tool_result_limit": "Tool result limit (chars)",
    "aggressive": "aggressive",
    "default": "default",
    "reserve_tokens": "Reserve tokens",
    "threshold_pct": "Trigger at {{pct}}% of context window",
    "help": "For huge sessions a cheaper compact model (e.g. claude-haiku) and lower tool-result limit (500) helps. Threshold < 100% triggers early — protects against context-window crashes.",
    "live_truncation": "Live truncation (chars)",
    "live_truncation_disabled": "No limit",
    "live_truncation_help": "Truncates individual tool results to X chars before they enter the LLM context. 0 = no limit. Recommended: 12000.",
    "cache_ttl": "Prompt cache TTL",
    "cache_ttl_help": "How long Anthropic caches the system prompt. 1h = cache persists across sessions (2× write cost). 5m = Anthropic default (cheaper writes, but cache expires sooner).",
    "max_turns": "Max messages (turn net)",
    "max_turns_auto": "auto",
    "max_turns_help": "Compaction also fires when the message count reaches this value — independent of tokens. Empty = automatic (scales with the context window, e.g. 5000 at 1M). Only set it if a tool-heavy agent compacts too early.",
    "reserve_help": "Only takes effect when larger than the headroom derived from the trigger %. At trigger < 100% the percentage usually wins (e.g. 75% of 1M = 250k reserve → this value then has no effect)."
  },
  "model_picker": {
    "search": "Search model…",
    "all_providers": "All providers",
    "only_free": "free only",
    "count": "{{shown}} of {{total}} models",
    "current": "(current)",
    "none": "No model matches the filter."
  }
}
